var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interview-success-message text-center py-6"},[_c('v-icon',{staticClass:"mb-4",attrs:{"color":"success","size":"64"}},[_vm._v("mdi-check-circle")]),_c('div',{staticClass:"text-h6 mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }